import { render, staticRenderFns } from "./GradingPlans.vue?vue&type=template&id=60f7fba8&"
import script from "./GradingPlans.vue?vue&type=script&lang=js&"
export * from "./GradingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports